export default __webpack_public_path__ + "static/media/Alien.bea3c77e.mp4";